import { useLocation } from "react-router-dom";

import { AppOriginType, RouterState } from "../../Routes.types";

export const useAppOrigin = (): AppOriginType | null => {
    const location = useLocation<RouterState>();

    return location.state?.appOrigin ?? null;
};
